import zhLocale from 'element-ui/lib/locale/lang/zh-TW'

const zhTw = {
    ...zhLocale,
    refresh: '重新整理',
    Save_cmd: '存檔',
    Close_cmd: '關閉視窗',
    Del_cmd: '刪除',
    Query_cmd: '查詢',
    Send_cmd: '確認送出',
    Submit_cmd: '提交',
    Sign_in: '登入',
    Sign_Out: '登出',
    Confirm_txt: '確定',
    Load_txt: '載入中',
    Error_txt: '錯誤',
    Success_txt: '成功',
    Warning_txt: '警告',
    Info_txt: '消息',
    Upload_txt: '點擊上傳',
    Anno_txt: '最新公告',
    Report_txt: '報表',
    Excel_txt: '試算表',
    Preview_txt: '上一頁',
    NextPage_txt: '下一頁',
};

export default zhTw;